<template>
  <div class="zer" style="width:100%;position:absolute;left:0;">
  <div class="zer-main" id="zer-main" style="background:#fff;width:1020px;margin:0 auto;">
    <a class="noprint Printing-btn" href="javascript:window.print()">打印</a>
    <div class="zerRep" id="zerRep">
      <div class="report-zer "><!-- watermark-srm -->
      <div class="emergency-btn fr" style="text-align:center; line-height:30px; margin:22px 80px 0 0;">{{patientRep.clinicType}}</div>
      <div class="zer-report-head">
        <div class="hos-name">{{patientRep.hosName}}</div>
        </div>
      <h2>{{patientRep.examTypeName}}检查诊断报告单<span v-show="patientRep.clinicType!=undefined">（{{patientRep.clinicType}}）</span></h2>
      <div class="zer-report clearfix">
        <div class="zer-report-l">
          <ul class="infor infor-top">
            <li class="clearfix"><label>姓 名</label><span>{{patientRep.patientName}}</span></li>
            <li class="clearfix"><label>姓 别</label><span>{{patientRep.patientSex}}</span></li>
            <li class="clearfix"><label>年 龄</label><span>{{patientRep.patientAge}}</span></li>
            <li class="clearfix"><label>{{patientRep.examTypeName}} 号</label><span>{{patientRep.accessionNumber}}</span></li>
            <li class="clearfix"><label>影 像 号</label><span>{{patientRep.accessionNumber}}</span></li>
            <li class="clearfix"><label>科 室</label><span>{{patientRep.requestDepartment}}</span></li>
            <li class="clearfix"><label>检查项目</label><span>{{patientRep.examBodyName}}</span></li>
          </ul>
          <div class="infor infor-btm">
            <ul class="rtd">
              <li class="clearfix"><label>审核医生</label><span>{{patientRep.approveDoctor}}</span></li>
            </ul>
            <div class="atg">
              <img src="" alt=""/>
            </div>
            <div class="adt">
              <ul>
                <li><label>报告书写</label><span>{{patientRep.reportDoctor}}</span></li>
                <li><label>检查时间</label><span>{{patientRep.studiesDoneDts[0]}}&nbsp;</span><span>{{patientRep.studiesDoneDts[1]}}</span></li>
                <li><label>报告时间</label><span>{{patientRep.approveDts[0]}}&nbsp;</span><span>{{patientRep.approveDts[1]}}</span></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="zer-report-r">
          <div class="details-top clearfix">
            <p class="details-n">影像所见 :</p>
            <div class="details-c">
              <!--<p>急诊头颅CT</p>-->
              <p>{{patientRep.reportEvidences}}</p>
              <!--<p>
                左锁骨中外1/3处骨折复查。左锁骨中外可见明显骨痂形成。左锁骨中外1/3处骨折复查，骨折端略向下位移，可见明显骨痂形成。左锁骨中外可见明显骨痂形成。左锁骨中外1/3处骨折复查，</p>
              <p>
                左锁骨中外1/3处骨折复查。左锁骨中外可见明显骨痂形成。左锁骨中外1/3处骨折复查，骨折端略向下位移，可见明显骨痂形成。左锁骨中外可见明显骨痂形成。左锁骨中外1/3处骨折复查，</p>-->
            </div>

          </div>
          <div class="details-btm clearfix">
            <p class="details-n">影像诊断 :</p>
            <div class="details-c">
              <p> {{patientRep.reportConclusion}}</p>
<!--              <p> 左锁骨中外1/3处骨折复查，左锁骨中外可见明显骨痂形成。左锁骨中外1/3处骨折复查，骨折端略向下位移，可见明显骨痂形成。</p>-->
            </div>

          </div>
        </div>
      </div>

    </div>
      <div class="zer-footer">
      <ul>
        <li>*请凭此报告单到取片处取片</li>
        <li>*此单仅供本院医师参考，不做证明</li>
      </ul>
    </div>
    </div>
  </div>
  </div>
</template>
<script type="text/ecmascript-6">
  import {changehosArea,changeclinicType} from '@/common/js/change'
  export default {
    data() {
      return {
        patientRep:{},
        hosA:''
      }
    },
    mounted() {

    },
    methods: {
    },
    created() {
      this.patientRep = JSON.parse(sessionStorage.getItem('zerRep'));
      //this.patientRep.hPatientType = sessionStorage.getItem('hPatientType');
      this.patientRep.studiesDoneDts = this.patientRep.studiesDoneDt.split(' ');
      this.patientRep.approveDts = this.patientRep.approveDt.split(' ');
      this.hosA = changehosArea(this.patientRep.hosArea)
    }
  }
</script>

<style scoped lang="stylus" rel="stylesheet/stylus" >
  @import '~@/common/css/variable'
  @media print{
    .noprint {
      display : none;
    }
    .zerRep{
      font-size:14px;
    }
    .zer-report .zer-report-l label{
      width:120px !important;
    }
    .zer-report .zer-report-l{
      width:290px;
    }
    .zer-main .adt ul li{
      width:300px;
    }
    .zer-footer li{
      font-size:20px !important;
    }
    .zer-report-r .details-n,.zer-report-r .details-c p{
      line-height:1.8em !important;
    }
    .zer-report-r .details-c p{
      min-height: 282px !important;
      text-align:justify
    }
  }
  .zer-main
    color: #000;
    font-size: 80%
    border-top:1px solid transparent;
    position: relative;
    margin:0 auto;
    //padding: 4em;
    padding:4em 2em 1em 2em

  .report-zer
    border: 1px solid black;

  .zer-main .report-zer
    padding: 3% 0 0;
    background-color: #fff;
    position: relative;

  .zer-report-head
    padding:0 0 28px 20px;
    color: #173D86;

  .zer-report-head img
    float: left;
    margin-left: 20px;

  .zer-report-head .hos-name
    font-size: 2.8em;
    font-family: '微软雅黑';
    font-weight: bold;
    span
      font-weight: bold;
  .zer-report-head p
    line-height: 20px;

  .emergency-btn
    color: #000;
    border: 1px solid black;
    width: 80px;
    font-size: 2em;
    font-weight: bold;
    position: absolute;
    right: 0;
    background:#fff;

  .report-zer h2 span
    margin-left: 10px;
    font-weight bold

  .zer-report
    font-size: 1.7em;

  .zer-main .report-zer h2
    border-top: 1px solid black;
    border-bottom: 1px solid black;
    padding: 20px 0 20px 200px;
    font-weight: bold;
    font-size: 2.2em;


  .zer-main .zer-report-l
    float: left;
    padding-left: 16px;

  .zer-report .zer-report-r
    float: left;
    width: 690px;

  .zer-report .zer-report-l
    height: 1260px;
    border: none;
    //width: 230px;
    border-right: 1px solid black;
    position: relative;

  .zer-report .infor-btm
    position: absolute;
    bottom: 50px;

  .zer-main .atg
    overflow: hidden;
    margin-top: 68px;

  .zer-main .atg img
    max-height: 80px;
    max-width: 170px;
    float: right;

  .zer-main .atg
    margin-top: 20px;

  .zer-report .zer-report-l label
    width: 80px;
    display: inline-block;
    text-align-last: justify;
    margin-right: 28px;
    line-height:1.5em;

  .zer-report .zer-report-r
    border: none;
    padding: 24px 0 0 20px;

  .zer-report .infor-top li
    width: auto;
    line-height: 24px;
    margin: 25px 0;
    float: none;

  .infor-top li label, .infor-top li span, .rtd li label, .rtd li span
    float: left;

  .infor-top li span, .rtd li span
    width: 120px;
    word-wrap:break-word;
    line-height:1.5em;

  .zer-main .ms p
    text-indent: 0;

  .zer-main .adt
    margin-top: 20px;

  .zer-main .adt ul li
    float: none;
    line-height: normal;
    margin: 10px 0;
    overflow: hidden;

  .zer-main .adt li label
    float: left;
    height: 46px;

  .zer-main .adt li span
    display: block;

  // .zer-main .details-top
  //   font-size: 1.8em;

  .details-btm
    margin-top: 1.5em;

  .zer-report-r .details-n
    float: left;
    color: #525252;
    line-height 1.8em

  .zer-report-r .details-c
    float: left;
    width: 560px
    margin: 0 0 0 10px;

  .zer-report-r .details-c p
    margin-bottom: 20px;
    line-height 1.8em
    letter-spacing:1px
    min-height: 238px;

  .zer-footer
    overflow: hidden;
    line-height 3em

  .zer-footer li
    float: left;
    width: 33%;
    color: grey;
    font-size: 1.6em;

  .zer-footer .telephone
    text-align: right;

  .Printing-btn
    position: absolute;
    top: 10px;
    right: 50px;
    width: 100px;
    height: 30px;
    text-align: center;
    font-size: 14px
    line-height: 32px;
    cursor: pointer;
    background: $color-background-hover;
    color: $color-background-d;
    border-radius: 4px;
</style>



// WEBPACK FOOTER //
// zerReport.vue?4ea88c29